<template>
    <div class="container" style="">
        <section>
            <h4>黄石市交易市场主体库</h4>
            <div class="center-cont">
                <div class="login_box">
                    <div class="login_title">
                         <span
                                 v-for="(item,index) in loginTypeList"
                                 :key="index"
                                 @click="changeLoginType(index)"
                                 :class="loginTypeActive == index ? 'active' : null">
                           {{item}}
                         </span>
                    </div>
                    <div class="login-type" v-if="loginTypeActive == 0">
                        <div class="login-input">
                            <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
                                     @keyup.enter.native="dataFormSubmit()"
                                     status-icon>
                                <el-form-item prop="usernameForInput">
                                    <el-input v-model="dataForm.usernameForInput" @blur="onInputBlur" placeholder="帐号"
                                              prefix-icon="el-icon-user"></el-input>
                                </el-form-item>
                                <el-form-item prop="passwordForInput">
                                    <el-input v-model="dataForm.passwordForInput" type="password" placeholder="密码"
                                              prefix-icon="el-icon-lock"></el-input>
                                    <el-tooltip class="item" effect="dark" :content="PwdRemindcontent" placement="top">
                                        <img :class="isPwdRemind == false ? 'notPwdTip' : 'pwdTip'" src="../../assets/images/icon-pwTip.png" alt="">
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item prop="captcha">
                                    <el-row>
                                        <el-col :span="13">
                                            <el-input v-model="dataForm.captcha" placeholder="验证码">
                                            </el-input>
                                        </el-col>
                                        <el-col :span="10" class="login-captcha">
                                            <img :src="captchaPath" @click="getCaptcha()"
                                                 style="margin-left:33px;height: 40px" alt="">
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-button class="login-btn radius3" style="padding: 0px 0px;" type="primary"
                                           @click="dataFormSubmit()">登录
                                </el-button>
                                <p class="helpMode">
                                    <span @click="()=>{this.$router.push({path:'/register'})}">
                                        企业注册
                                    </span>
                                    <span @click="()=>{this.$router.push({path:'/forgetPassword'})}">
                                        忘记密码
                                    </span>
                                </p>
                            </el-form>
                        </div>
                    </div>
                    <div class="login-type" v-if="loginTypeActive == 1">
                        <div class="login_cont">

                        </div>
                        <button style="width: 80%" @click="CALogin">立即登录</button>
                    </div>
                    <div class="login-type" v-if="loginTypeActive == 2">
                        <div class="login-code">

                        </div>
                    </div>
                    <p style="width:100%;cursor:pointer;text-align: center;color: rgba(0,0,0,.65);font-size: 14px;margin-top: 15px">
                        登录即代表您已同意
                        <router-link class="notice" target="_blank" :to="'/register/info'">
                            <span>《黄石公共市场主体用户须知》</span>
                        </router-link>
                    </p>
<!--                    <p style="width:100%;cursor:pointer;text-align: left;color: #4D69F6;margin-top: 15px;padding: 0 0 0 35px" @click="toRegister">还没注册？点这里~</p>-->
                </div>
                <div class="center-tips">
                    <h4>平台帮助</h4>
                    <ul>
                        <li v-for="(item,index) in questionList" :key="index" @click="toDetail(item,index)" :title="item.title">
                            <i></i>
                            {{item.title}}
                        </li>
<!--                        <router-link class="notice" target="_blank" :to="{name:'questionDiscretionDetail',params:{item:item,index:index}}">-->
<!--                            {{item.title}}-->
<!--                        </router-link>-->
                    </ul>
                    <p>
                        <a href="http://cjdown.pminfo.cn/hs/品茗驱动V1.5.exe"><span><i></i>驱动下载</span></a>
                        <a href="https://www.hsztbzx.com:443/attachment/download?id=733a8dc5134249388492525eb8e9813d"><span><i></i>投标工具下载</span></a>
                    </p>
                </div>
            </div>
            <div class="step-tips">
                主体库办理流程：办理CA数字证书——使用CA数字证书登录——完善主体信息并提交——入库成功
            </div>
        </section>
        <el-dialog :visible.sync="dialogVisibleFlag" width="660px">
            <div slot="title" class="dialog-title">
                <i class="el-icon-warning-outline" style="font-size: 20px;color: #FF9A2C;margin: 0 9px 0 0"></i>
                <span class="title-text" style="font-size: 18px;color: #FF9A2C">温馨提示</span>
                <div class="button-right">
                    <span class="title-close" @click="cancelDialog"></span>
                </div>
            </div>
            <div>
                <p style="color: #000000;margin: 0 0 8px 0;">检测到未使用IE浏览器访问本网站，为保障您的正常入库，请提前做如下操作：</p>
                <p style="color: rgba(0, 0, 0, 0.45);">1、<a style="color: #1890FF" href="http://cjdown.oss.aliyuncs.com/lh/品茗驱动（河南互认）V1.5.exe">下载</a>并完整安装驱动（已安装可忽略）</p>
                <p style="color: rgba(0, 0, 0, 0.45);">2、使用IE浏览器访问本网站，或含IE内核浏览器且切换至兼容模式，切换方式如下图：</p>
                <img style="margin: 24px 0;" src="../../assets/img/login-tips.png" alt="">
                <p style="color: rgba(0, 0, 0, 0.45);">含IE内核的浏览器主要有：360浏览器、QQ浏览器、猎豹浏览器、百度浏览器等。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="dialogVisibleFlag = false" style="margin: 0 42px 0 0">我知道了</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../../utils/jquery.1.12.4.min.js';
    import {isURL} from '@/utils/validate'
    import {initCa, getCaInfo, SignData} from '../../utils/CertTools'
    import {EnableCA ,createRandom,auth} from'../../utils/CA'
    import {getUUID, loginByJwt} from '../../utils/index'
    import axios from 'axios'

    const ssoHttp = axios.create({
        timeout: 1000 * 30,
        withCredentials: true,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=utf-8',
            'Cache-Control': 'no-cache'
        }
    })
    // ssoHttp.interceptors.request.use(
    //     config => {
    //         config.params = {...config.params, timestamp: Date.now()};
    //         config.headers.Authorize = localStorage.getItem('token') || '';
    //         return config
    //     },
    //     error => Promise.reject(error)
    // );

    export default {
        data() {
            return {
                loginTypeFlag:false,
                dialogVisibleFlag:false,
                isPwdRemind:false,
                PwdRemindcontent:'',
                dataForm: {
                    usernameForInput: '',
                    passwordForInput: '',
                    uuid: '',
                    captcha: ''
                },
                captchaPath: '',
                dataRule: {
                    usernameForInput: [
                        {required: true, message: '帐号不能为空', trigger: 'blur'}
                    ],
                    passwordForInput: [
                        {required: true, message: '密码不能为空', trigger: 'blur'}
                    ],
                    captcha: [
                        {required: true, message: '验证码不能为空', trigger: 'blur'}
                    ]
                },
                loginTypeList: ['账号登录','CA登录'],
                // loginTypeList: [],
                loginTypeActive: 0,
                //ca绑定
                CAData: {
                    username: '',
                    password: '',
                    captcha: '',
                    caCode: '',
                    friendlyName: '',
                    expireDate: '',
                    fromDate: '',
                    remark: '',
                },
                //CA
                CAInfo: {
                    signData: '',
                    loginType: 1,
                    traddingOrgId: '',
                    caCode: '',
                    caLegalCode: '',//社会信用代码
                    friendlyName: '',
                    fromDate: '',//有效期开始时间
                    expireDate: '',//有效期结束时间
                    caName: '',
                    appCode: window.SITE_CONFIG.appCode,
                    appId: 'e090d9885a534dacb0e0103fd1cde816',
                    uuid: getUUID(),
                    password: '',
                    username: '',
                    useCaptcha: 1,
                    backUrl: '',
                    captcha: '',
                    legalCode: ''
                },
                questionList:[],
            }
        },
        created() {
            console.log(this.isIEBrowser())
            if(this.isIEBrowser()){
                this.dialogVisibleFlag = true;
            }
            this.getCaptcha();
            this.getPlatformHelp();
            if(process.env.NODE_ENV !== 'production'){
                this.loginTypeFlag = true
            }
            let locationStr = location.href;
        },
        methods: {
            cancelDialog(){
                this.dialogVisibleFlag = false;
            },
            // 失去焦点显示密码提示
            onInputBlur() {
                if(this.dataForm.usernameForInput){
                    this.isPwdRemind = true;
                    this.$http.post('/oauth/getPassWordRemind', {
                        username:this.dataForm.usernameForInput
                    }).then(res => {
                        if(res.data && !!res.data.data){
                            this.PwdRemindcontent = res.data.data
                        }
                    })
                }else{
                    this.isPwdRemind = false;
                }
            },
            //判断是否为IE内核浏览器
            isIEBrowser() {
                var u = window.navigator.userAgent.toLocaleLowerCase();
                var msie = /(msie) ([\d.]+)/;
                var chrome = /(chrome)\/([\d.]+)/;
                var firefox = /(firefox)\/([\d.]+)/;
                var safari = /(safari)\/([\d.]+)/;
                var opera = /(opera)\/([\d.]+)/;
                var ie11 = /(trident)\/([\d.]+)/;
                var b = u.match(msie)||u.match(chrome)||u.match(firefox)||u.match(safari)||u.match(opera)||u.match(ie11);
                if(b[1] == "msie" || b[1] == 'trident'){
                    return false;
                }else{
                    return true;
                }
            },
            changeUserType(val) {

            },
            // 提交表单
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$http.post('/oauth/login', {
                            'backUrl': '',
                            'loginType': 0,
                            'useCaptcha': 1,
                            'appCode': window.SITE_CONFIG.appCode,
                            'username': this.dataForm.usernameForInput,
                            'password': this.dataForm.passwordForInput,
                            'uuid': this.dataForm.uuid,
                            'captcha': this.dataForm.captcha
                        }).then(res => {
                            if (res.data.code == '1') {
                                this.loginByJwt(res.data.authCode)
                                localStorage.setItem('token', res.data.authCode);
                            } else {
                                this.getCaptcha();
                                this.$message.error(res.data.msg)
                            }
                        })
                    }
                })
            },
            changeLoginType(index) {
                // this.loginTypeActive = index;
                if(this.loginTypeList.length >= 2){
                    this.loginTypeActive = index;
                }else{
                    this.loginTypeActive = 0;
                }
            },
            //初始化CA
            CALogin() {
                var that = this;
                //启用CA
                EnableCA(1,function (cert) {
                    that.CASubmit(cert);
                });
                // initCa((isIE) => {
                //     if (!isIE) {
                //         alert("初始化验证失败，请使用ie浏览器登录并检查ie配置项!");
                //     }
                // })
                // getCaInfo((certInfo) => {

                //
                // })
                // console.log('111',this.CAInfo)
                // this.affirmCA();
            },
            CASubmit(cert) {
                //p7签名不传content
                var c = createRandom();
                this.CAInfo.traddingOrgId = this.$cookie.get('traddingOrgId');
                this.CAInfo.caCode = cert.SerialNumber.toString();
                this.CAInfo.legalCode = cert.Subject.split('=')[2].split(',')[0];
                this.CAInfo.friendlyName = cert.friendlyName;
                this.CAInfo.fromDate = cert.NotBeforeSystemTime;
                this.CAInfo.expireDate = cert.NotAfterSystemTime;
                this.CAInfo.caName = cert.friendlyName;
                this.CAInfo.signData = auth(cert,c);
                this.affirmCA();

            },
            //ca登录
            affirmCA() {
                if (!this.CAInfo.signData) {
                    this.$alert('请确认湖北CA的UKEY是否正确插入', '提示', {
                        confirmButtonText: '确定',
                    });
                    return;
                }
                this.$http.post('/sys/login', this.CAInfo).then(({data}) => {//本地登录确认CA
                    if (data && data.code === '1') {
                        this.basePlatformLogin();
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            //基础平台登录接口
            basePlatformLogin() {
                this.$http.post('/oauth/login', this.CAInfo).then(res => {
                    if (res.data.code == '1') {
                        this.loginByJwt(res.data.authCode)
                        localStorage.setItem('token', res.data.authCode);
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            loginByJwt(token) {
                this.$http.post('/oauth/tokenLogin?token=' + token, {
                    token: token
                }).then(({data}) => {
                    if (data.code === '1') {
                        let url = this.$route.query.redirect_uri;
                        if (url) {
                            console.log(url)
                            // 由于ajax调用，不能回退到原来地址.
                            this.$router.push({name: 'home'})
                        } else {
                            this.$router.push({name: 'home'})
                        }
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            //处理CA获取的时间
            formFilter(data) {
                var qyear = new Date().getFullYear();
                var q2year = qyear.toString().slice(0, 2);
                var time = q2year + data;
                var year = time.substring(0, 4);
                var month = time.substring(4, 6);
                var date = time.substring(6, 8);
                var hour = time.substring(8, 10);
                var minute = time.substring(10, 12);
                var second = time.substring(12, 14);
                // console.log(time,year,month,date,hour,minute,second)
                return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
            },
            //获取验证码
            getCaptcha() {
                this.dataForm.uuid = getUUID()
                // this.captchaPath = this.$http.adornUrl(`/sso/captchaCode.png?uuid=${this.dataForm.uuid}`)
                this.$http.get(`/ent/captchaCode.png?uuid=${this.dataForm.uuid}`, {
                    responseType: 'arraybuffer'
                }).then(response => {
                    return 'data:image/png;base64,' + btoa(
                        new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    )
                }).then(data => {
                    this.captchaPath = data
                })
            },
            noticeToUsers(){ //用户须知
                this.$router.push('/register');
            },
            //获取平台帮助列表
            getPlatformHelp(){
                this.$http.post('/question-help/qa-list',{
                    page: 1,
                    rows: 10,
                    filter: {
                        key: ''
                    },
                    searchKey: '',
                    orderBy: 'create_time desc'
                }).then(res=>{
                    this.questionList = res.data.rows;
                })
            },
            toDetail(item,index){
                let routeOne = this.$router.resolve({path:'/questionDiscretion/detailLogin',query:{id:item.id,index:index}});
                window.open(routeOne.href, '_blank');
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-form-item.is-success .el-input__validateIcon{
        display: none;
    }
    /deep/ .el-form-item.is-error .el-input__validateIcon{
        display: none;
    }
    .container {
        background: url("../../assets/img/login_bg.png") no-repeat;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        /deep/ .el-input__inner {
            background: #FFFFFF;
            height: 44px;
            border: 1px solid #1890FF;
            border-radius: 3px;
        }

        /deep/ .el-form-item {
            margin-bottom: 25px;
        }

        /deep/.el-dialog__body{
            padding: 10px 40px 70px 40px;
        }

        header {
            width: 100%;
            height: 100px;
        }

        section {
            width: 1200px;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            h4{
                font-size: 32px;
                font-weight: bold;
                color: #FFFFFF;
                margin: 0 0 24px 0;
            }
            .center-cont {
                height: 430px;
                display: flex;
                border-radius: 2px;
                box-shadow: 0px 0px 30px 0px rgba(70, 127, 221, 0.4);
                background: #ffffff;

                .login_box {
                    width: 490px;
                    height: 100%;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 28px 0;

                    .login_title {
                        width: 100%;
                        height: 40px;
                        border-bottom: 3px solid #eeeeee;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        span {
                            height: 100%;
                            padding: 0 20px;
                            border-bottom: 3px solid #eeeeee;
                            margin-bottom: -6px;
                            font-size: 18px;
                            cursor: pointer;
                        }

                        span.active {
                            border-bottom: 3px solid #1890FF;
                            margin-bottom: -6px;
                            color: #1890FF;
                        }
                    }

                    .notice{
                        span{
                            color: #1890FF
                        }
                    }

                    .notice:focus,.notice:hover{
                        color: #1890FF;
                    }

                    .login-type {
                        width: 100%;
                        height: 290px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        .pwdTip{
                            margin-right: 20px;
                            position: absolute;
                            top: 13px;
                            right: -43px;
                        }
                        .notPwdTip{
                            display: none;
                        }
                    }

                    .login_cont {
                        width: 80%;
                        height: 180px;
                        border: 1px solid #CCCCCC;
                        background: url("../../assets/img/login_cont.png") no-repeat center center;
                        margin: 20px 0;
                    }

                    .login-input {
                        width: 86%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;

                        p {
                            span {
                                font-weight: bold;
                            }
                        }
                        .helpMode{
                            display: flex;
                            justify-content: flex-end;
                            margin-top: 12px;
                            span{
                                font-size: 12px;
                                color: #666;
                                font-weight: normal;
                                cursor: pointer;
                            }
                            span:nth-child(1){
                                margin-right: 12px;
                            }
                        }
                    }

                    .login-code {
                        width: 80%;
                        height: 180px;

                    }

                    button {
                        width: 100%;
                        background: #1890FF;
                        border: 0;
                        outline: 0;
                        height: 56px;
                        border-radius: 3px;
                        color: #ffffff;
                        cursor: pointer;
                    }

                    button:hover {
                        /*box-shadow: 0 0 1px 1px rgba(0, 0, 0, .5);*/
                    }
                }

                .center-tips {
                    width: 305px;
                    height: 100%;
                    color: #1890FF;
                    padding: 0 15px;
                    background: rgba(255, 255, 255, .3);
                    h4 {
                        font-size: 16px;
                        font-weight: bold;
                        margin: 20px 0;
                        padding: 0 9px;
                        color: #1890FF;
                    }
                    ul {
                        width: 100%;
                        height: 270px;
                        li {
                            width: 260px;
                            height: 27px;
                            line-height: 27px;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                            cursor: pointer;
                            i {
                                display: inline-block;
                                width: 3px;
                                height: 3px;
                                background: rgba(24, 144, 255, 0.85);
                                margin: 0 9px 3px 9px;
                            }
                        }
                    }

                    p {
                        display: flex;
                        padding: 0 9px;
                        justify-content: space-between;
                        margin: 30px 0 0 0;
                        a{
                            span {
                                padding: 13px;
                                font-size: 14px;
                                font-weight: 400;
                                display: flex;
                                align-items: center;
                                cursor: pointer;
                                i{
                                    width: 14px;
                                    height: 14px;
                                    margin: 0 8px 0 0;
                                }
                            }
                        }

                        a:focus,a:hover{
                            text-decoration:none;
                        }

                        a:nth-child(1){
                            span{
                                background: rgba(255, 255, 255, 0.5);
                                border: 1px solid #1890FF;
                                border-radius: 2px;
                                color: #1890FF;
                                i{
                                    background: url("../../assets/img/login-icon-1.png") no-repeat center;
                                }
                            }
                        }
                        a:nth-child(1):focus,a:nth-child(1):hover{
                            span{
                                background: rgba(255, 255, 255, 0.5);
                                border: 1px solid #1890FF;
                                border-radius: 2px;
                                background: #1890FF;
                                color: #fff;
                                i{
                                    background: url("../../assets/img/login-icon-1-1.png") no-repeat center;
                                }
                            }
                        }
                        a:nth-child(2){
                            span{
                                background: rgba(255, 255, 255, 0.5);
                                border: 1px solid #FE8F3B;
                                border-radius: 2px;
                                color: #FE8F3B;
                                i{
                                    background: url("../../assets/img/login-icon-2.png") no-repeat center;
                                }
                            }
                        }
                        a:nth-child(2):focus,a:nth-child(2):hover{
                            span{
                                background: rgba(255, 255, 255, 0.5);
                                border: 1px solid #FE8F3B;
                                border-radius: 2px;
                                background: #FE8F3B;
                                color: #fff;
                                i{
                                    background: url("../../assets/img/login-icon-2-1.png") no-repeat center;
                                }
                            }
                        }
                    }
                }
            }

        }

        .step-tips{
            width: 100%;
            height: 50px;
            text-align: center;
            line-height: 50px;
            font-size: 14px;
            font-weight: bold;
            color: #FFFFFF;
            background-image: linear-gradient(to right, rgba(0,0,0,0),rgba(0,0,0,.1),rgba(0,0,0,.1),rgba(0,0,0,0));
            margin: 10px 0 0 0;
        }

        footer {
            width: 100%;
            height: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            p {
                margin: 10px;
                font-weight: bold;
            }
        }
    }

</style>
